import { useRef } from 'react';

// Once content has animated in, keep it eligible to animate for the rest of the
// component's life so a later re-render can't restart or suppress the effect.
export function useLatchedAnimationEligibility(
    animateContent: boolean,
): boolean {
    const hasAnimationStartedRef = useRef(false);
    if (animateContent) {
        hasAnimationStartedRef.current = true;
    }
    return hasAnimationStartedRef.current;
}
